import { createFileRoute } from '@tanstack/react-router';

import { PatientDetailPage } from '@/features/emr/pages/PatientDetailPage';

export const Route = createFileRoute('/_authenticated/patients/$patientId')({
  component: PatientDetailPage,
  beforeLoad: () => ({
    breadcrumbs: [
      { href: '/patients', title: 'Patients' },
      { title: 'Patient Detail' },
    ],
  }),
});
